<template>
  <nav class="pagination-wrapper" v-if="pageCount > 0"> 
    <ul class="pagination">
      <li :class="{disabled: currentPage == 1}">
        <a @click="changePage(currentPage - 1)" >
          <font-awesome-icon :icon="['fas', 'chevron-double-left']"/>        
        </a>
      </li>
      <span v-for="item, index in pages" :key="index"> 
  
        <li :class="{'active_item': currentPage == item, disabled: currentPage == item}" > 
          <a @click="item == '...' ? '#' : changePage(item)" >   {{item}} </a>
        </li>
      </span> 
      <li :class="{disabled: currentPage >= pageCount}" >
        <a @click="changePage(currentPage + 1)" >
          <font-awesome-icon :icon="['fas', 'chevron-double-right']"/>    
        </a>
      </li>
    </ul>
  </nav>
</template>
<script>
  export default {
    props: ['items', 'pagination_limit', 'page_count', 'top_id', 'expansion_threshold'],
    data() {
      return {
        pageNumber: 1,
        visibleItems: [],
        pageCount: 1,
        currentPage: 1,
        pages: []
      }
    },
    mounted() {
      // this.paginationLimit = parseInt(this.pagination_limit)
      this.paginationLimit = Number(this.pagination_limit)
      this.pageCount = Number(this.page_count ?? 0)
      this.setupPages()
      this.paginate()
    },
    watch: {
      items() {
        this.setupPages()
        this.paginate()
        this.changePage(1)
      }
    },

    methods: {
      setupPages() {
        this.pageCount = this.page_count == null ? Math.ceil(this.items.length/parseFloat(this.pagination_limit)) : this.page_count
        const params = new URLSearchParams(window.location.search);
        let page = params.get('page')
        this.currentPage =  page == null || page > this.pageCount ? 1  : parseInt(page)
        if(this.page_count == null) {
          this.changePage(this.currentPage)
        }
      },
      paginate() {
        if(this.pageCount < (parseInt(this.expansion_threshold) || 10)) {
          // this.pages = [...Array(this.pageCount).keys()].map(i => i + 1)
          this.pages = Array.from({ length: this.pageCount }, (_, i) => i + 1)
        }
        else {
          //The number of pages exceeds the set expansion threshold
          //use [1][2][3]...[49][50][51]...[98][99][100] format

          // Start with the first three
          let paginationList = [1,2,3]

          // Get the middle three
          let nextUp = this.currentPage
          nextUp = this.currentPage < 6 ? 5 : nextUp
          nextUp = this.currentPage > this.pageCount-4 ? this.pageCount-4 : nextUp
          paginationList = paginationList.concat([nextUp-1, nextUp, nextUp+1])

          // Finish with the last three
          paginationList = paginationList.concat([this.pageCount-2, this.pageCount-1, this.pageCount])
          //Add ellipses as needed
          if(this.currentPage > 5) {
            paginationList.splice(3, 0, '...')
          }
          if(this.currentPage < this.pageCount-4) {
            paginationList.splice(-3, 0, '...') 
          }
          this.pages = paginationList
        }
      },
      changePage(page) {
        // There are two ways we handle pagination, either we are paginating the items on the frontend or they are already paginated and we are just 
        // displaying the number links at the bottom of the page. We determine which one based on whether or not we get a page_count passed to us
        if(this.page_count) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', page)
          window.location.replace(url.toString())
          return
        }

        this.currentPage = page < 1 || page > this.pageCount ? 1 : page 
        let startingIndex = (this.currentPage-1)*this.paginationLimit
        this.visibleItems = this.items.slice(startingIndex, startingIndex + this.paginationLimit)
        if (this.top_id) {
          const element = document.getElementById(this.top_id);
          element.scrollIntoView();
        } else {
          if (this.currentPage !== page) {
            window.scrollTo({top: 0, behavior: 'smooth'});
          }

          
        }

        this.$emit('items_changed', this.visibleItems)
        this.loading = true
      }
    }

  }
</script>
